<template>
  <div class="customization-group-selector-card">
    <pdl-card :qaid="`customization-group-card-${componentName}`">
      <template #bodyContent>
        <input
          :id="`option-${componentOptionId}`"
          type="radio"
          name="customization-group"
          :checked="isSelected"
          :aria-labelledby="`name-${componentOptionId} price-${componentOptionId} description-${componentOptionId}`"
          class="absolute block top-0 left-0 right-0 bottom-0 w-full h-full pointer-events-auto cursor-pointer z-10"
          @change="updateSelectedComponent"
        />
        <div class="relative grid grid-cols-3 mt-[0.125rem] mr-[0.125rem]">
          <div class="h-full">
            <image-component
              :asset-id="assetId || 'default-no-image'"
              :alt-text="`${componentName}`"
              aspect-ratio="1x1"
              transformation="fill"
              css-class="w-full h-full object-cover"
              :qaid="`customization-group-image-${componentName}`"
            />
          </div>
          <div
            class="bg-gray-05 py-1 px-[.625rem] col-span-2 customization-group-details"
            :qaid="`customization-group-details-${componentName}`"
          >
            <div class="mb-1">
              <label
                :id="`name-${componentOptionId}`"
                :for="`option-${componentOptionId}`"
                class="text-xs font-bold leading-normal"
                :qaid="`customization-group-name-${componentName}`"
              >
                {{ componentName }}
              </label>
              <div
                :id="`price-${componentOptionId}`"
                class="text-xs text-gray-60"
                :qaid="`customization-group-price-${componentName}`"
              >
                {{ priceDifference }}
              </div>
            </div>
            <div
              :id="`description-${componentOptionId}`"
              class="text-xs leading-normal w-full"
              :qaid="`customization-group-description-${componentName}`"
            >
              {{ description }}
            </div>
          </div>
        </div>
      </template>
    </pdl-card>
  </div>
</template>

<script>
import {PdlCard} from '@pedal/pdl-card';
import ImageComponent from '@/components/ImageComponent.vue';

export default {
  components: {
    PdlCard,
    ImageComponent,
  },
  props: {
    componentName: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    priceDifference: {
      type: String,
      default: '',
    },
    assetId: {
      type: String,
      default: '',
    },
    componentGroupId: {
      type: Number,
      required: true,
    },
    componentOptionId: {
      type: Number,
      required: true,
    },
    currentSelectionId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    isSelected() {
      return this.componentOptionId === this.currentSelectionId;
    },
  },
  methods: {
    updateSelectedComponent() {
      this.$emit('update-selection', this.componentOptionId);
    },
  },
};
</script>

<style lang="scss" scoped>
.customization-group-selector-card {
  transition: scale 0.1s ease-in, box-shadow 0.2s ease-in;
  box-shadow: 0 0 0 rgba(0, 0, 0, 0), 0 0 0 rgba(0, 0, 0, 0);
  scale: 1;

  &:has(input[type='radio']:active) {
    scale: 0.99;
  }

  &:has(input[type='radio']:checked) {
    box-shadow: 0 7px 6px -6px rgba(0, 0, 0, 0.25), 0 14px 15px -13px rgba(0, 0, 0, 0.3);
  }
}

:deep(.pdl-card__body) {
  padding: 0;
  pointer-events: none;

  &:focus-within,
  &:hover {
    .customization-group-details {
      background-color: var(--blue-10, #e6f2f8);
      opacity: 1;
    }
  }
}

input[type='radio'] {
  appearance: none;
  border-radius: 0;
  color: transparent;
  line-height: 0;
  transition: background-color 0.2s, color 0.2s, transform 0.1s;
  border: 0.125rem solid currentColor;
  background-color: #e6f2f800;

  &:checked {
    color: var(--blue-100, #007ab8);
  }

  @media (hover: hover) {
    &:hover {
      color: var(--blue-100, #007ab8);
    }
  }

  &:focus-visible {
    outline: 2px solid var(--blue-100);
    outline-offset: 0.125rem;
  }
}
</style>
